import { Link } from "react-router-dom"
import Logo from "../../../components/Logo"

const BlogNavbar = () => {

  return (
    <div className="blogHomeTopBarContainer">
      <div className="blogHomeNav">
        <Logo />
        <div>
          <Link className="blogHomeNavItem" to={`/`}>
            Portfolio
          </Link>
        </div>
        <div>
          <Link className="blogHomeNavItem" to={`/blog/`}>Reviews</Link>
        </div>

      </div>
    </div>

  )
}

export default BlogNavbar;